import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dateFormat from 'dateformat'
import { toast } from 'react-toastify'
import { fetchFileDocument, fetchFileRegenerateDocument, fetchUploadDocument } from '../../../utilities/API/document/documentAPI'

export const uploadDocument = createAsyncThunk(
    'uploadDoc', fetchUploadDocument
)


const initialState = {
   docDCaseId:[],
   isUploaded: false,
   uploadedSuccess: false
}

const uploadDocumentSlice = createSlice({
    name: 'uploadDownload',
    initialState,
    reducers: {
        resetuploadDocumentSlice: (state) => {
            state.docDCaseId=[];
            state.isUploaded=false;
            state.uploadedSuccess =false
            // toast.success("Applictions reseted Successfully")
        },
        resetIsUploaded: (state) => {
            state.isUploaded=false;
        },
        resetUploadSuccess: (state) =>{
            state.uploadedSuccess = false
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(uploadDocument.pending, (state, action) => {
                // toast.warn("applications list pending")
            })
            .addCase(uploadDocument.fulfilled, (state, action) => {

                    let data = action.payload?.res;
                    
                    
                   if( data?.pxResults?.length > 0){
                    state.docDCaseId = data?.pxResults
                    state.isUploaded=true;
                    state.uploadedSuccess =true
                   } else{
                    toast.error('Please try again in a few minutes')
                   }
            })
            .addCase(uploadDocument.rejected, (state, action) => {
                // toast.error(action.error.message)
            })




    },
})

export const { resetuploadDocumentSlice, resetIsUploaded, resetUploadSuccess } = uploadDocumentSlice.actions

export default uploadDocumentSlice.reducer